import type { Template } from "@/types";

export const LA_07_H2_V5: Template[] = [
{
    id: "la-07-h2v5-01",
    name: "LA 01 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 93, y: 89, width: 219, height: 148, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 244, width: 219, height: 147, rotation: 0, imageRotation: 0 },
            { id: "3", x: 319, y: 89, width: 225, height: 302, rotation: 0, imageRotation: 0 },
            { id: "4", x: 796, y: 40, width: 156, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 796, y: 243, width: 156, height: 195, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 40, width: 155, height: 195, rotation: 0, imageRotation: 0 },
            { id: "7", x: 960, y: 243, width: 155, height: 195, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-02",
    name: "LA 02 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 58, y: 56, width: 272, height: 177, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 241, width: 272, height: 177, rotation: 0, imageRotation: 0 },
            { id: "3", x: 337, y: 56, width: 241, height: 362, rotation: 0, imageRotation: 0 },
            { id: "4", x: 774, y: 57, width: 264, height: 362, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1045, y: 57, width: 89, height: 117, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1045, y: 180, width: 89, height: 117, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1045, y: 304, width: 89, height: 117, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-03",
    name: "LA 03 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 125, y: 44, width: 292, height: 191, rotation: 0, imageRotation: 0 },
            { id: "2", x: 125, y: 242, width: 292, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 425, y: 44, width: 89, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 425, y: 177, width: 89, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 425, y: 309, width: 89, height: 125, rotation: 0, imageRotation: 0 },
            { id: "6", x: 754, y: 91, width: 200, height: 296, rotation: 0, imageRotation: 0 },
            { id: "7", x: 961, y: 91, width: 199, height: 296, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-04",
    name: "LA 04 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 125, y: 44, width: 89, height: 125, rotation: 0, imageRotation: 0 },
            { id: "2", x: 125, y: 176, width: 89, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 125, y: 308, width: 89, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 221, y: 44, width: 292, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 221, y: 242, width: 292, height: 191, rotation: 0, imageRotation: 0 },
            { id: "6", x: 725, y: 69, width: 228, height: 338, rotation: 0, imageRotation: 0 },
            { id: "7", x: 960, y: 69, width: 227, height: 338, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-05",
    name: "LA 05 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 44, y: 146, width: 268, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 319, y: 146, width: 268, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 594, y: 146, width: 122, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 723, y: 146, width: 122, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 852, y: 146, width: 121, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 980, y: 146, width: 121, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1108, y: 146, width: 121, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-06",
    name: "LA 06 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 703, y: 75, width: 250, height: 156, rotation: 0, imageRotation: 0 },
            { id: "3", x: 703, y: 238, width: 122, height: 162, rotation: 0, imageRotation: 0 },
            { id: "4", x: 832, y: 238, width: 121, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 960, y: 75, width: 249, height: 156, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 238, width: 121, height: 162, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1088, y: 238, width: 121, height: 162, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-07",
    name: "LA 07 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 637, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 738, y: 35, width: 435, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 738, y: 319, width: 81, height: 120, rotation: 0, imageRotation: 0 },
            { id: "4", x: 826, y: 319, width: 81, height: 120, rotation: 0, imageRotation: 0 },
            { id: "5", x: 915, y: 319, width: 81, height: 120, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1004, y: 319, width: 81, height: 120, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1092, y: 319, width: 81, height: 120, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-08",
    name: "LA 08 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 221, y: 52, width: 124, height: 183, rotation: 0, imageRotation: 0 },
            { id: "2", x: 221, y: 242, width: 124, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 352, y: 52, width: 123, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 352, y: 242, width: 123, height: 182, rotation: 0, imageRotation: 0 },
            { id: "5", x: 483, y: 52, width: 288, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 483, y: 242, width: 288, height: 182, rotation: 0, imageRotation: 0 },
            { id: "7", x: 779, y: 52, width: 274, height: 372, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-09",
    name: "LA 09 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 85, width: 198, height: 304, rotation: 0, imageRotation: 0 },
            { id: "2", x: 205, y: 85, width: 198, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 411, y: 85, width: 449, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 85, width: 198, height: 304, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1071, y: 85, width: 204, height: 140, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1071, y: 232, width: 98, height: 157, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1176, y: 232, width: 98, height: 157, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h2v5-10",
    name: "LA 10 - H2V5",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h2_v5_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 85, width: 449, height: 304, rotation: 0, imageRotation: 0 },
            { id: "2", x: 456, y: 85, width: 198, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 661, y: 85, width: 198, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 85, width: 198, height: 304, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1071, y: 85, width: 204, height: 140, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1071, y: 232, width: 98, height: 157, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1176, y: 232, width: 98, height: 157, rotation: 0, imageRotation: 0 }
    ],
}
];